import { Box, Typography } from '@mui/material';
import React from 'react';

//TODO: add design for not found

const NotFoundPage = () => {
  return (
    <Box
      sx={{
        textAlign: "center",
        height: " 100%",
        display: "center",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Typography variant="h1">Not found page</Typography>
    </Box>
  );
};

export default NotFoundPage;
